import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './TransactionsDrawer.styles';
import { Drawer } from '@/components/Drawer/Drawer';
import { Transaction } from '@/mock-data/transactions';
import { formatNumber } from '@/utils/helpers';
import { AngleBackIcon } from '@/components/UI/Icons/Icons';
import { Typography } from '@/components/UI/Typography/Typography.styles';

interface TransactionDrawerProps {
  isOpen: boolean;
  close: () => void;
  transaction: Transaction | null;
}

export const TransactionsDrawer: React.FC<TransactionDrawerProps> = ({
  isOpen,
  close,
  transaction,
}) => {
  const { t } = useTranslation();

  if (!transaction) {
    return null;
  }

  return (
    <Drawer
      isOpen={isOpen}
      close={close}
      title={t('pages.cabinet.payment_number', {
        number: transaction.paymentNumber,
      })}
      hasBottomMargin={false}
    >
      {transaction.ad && (
        <S.Ad>
          <S.AdImage src={transaction.ad.image} alt="" loading="lazy" />
          <div>
            <S.Price $variant="2">
              {formatNumber(transaction.ad.price, 0)} AZN
            </S.Price>
            <S.Value $variant="4" isAlignLeft>
              {transaction.ad.name}
            </S.Value>
          </div>
          <AngleBackIcon isRotated />
        </S.Ad>
      )}
      <S.Box>
        <S.Logo>
          <img
            src="/Tap.svg"
            alt="Tap.Az"
            width={73}
            height={22}
            loading="lazy"
          />
        </S.Logo>
        <S.Row>
          <S.Name $variant="1">{t('pages.cabinet.date')}</S.Name>
          <S.Value $variant="1">{transaction.date}</S.Value>
        </S.Row>
        <S.Row>
          <S.Name $variant="1">
            {t('pages.cabinet.payment_number_title')}
          </S.Name>
          <S.Value $variant="1">{transaction.paymentNumber}</S.Value>
        </S.Row>
        <S.Row>
          <S.Name $variant="1">{t('pages.cabinet.ad_number')}</S.Name>
          <S.Value $variant="1">{transaction.adNumber}</S.Value>
        </S.Row>
        <S.Row>
          <S.Name $variant="1">{t('pages.cabinet.service')}</S.Name>
          <S.Value $variant="1">{transaction.service}</S.Value>
        </S.Row>
        <S.Row>
          <S.Name $variant="1">{t('pages.cabinet.payment_type')}</S.Name>
          <S.Value $variant="1">{transaction.paymentType}</S.Value>
        </S.Row>
        <S.Row>
          <S.Name $variant="1">{t('common.sum')}</S.Name>
          <S.Value $variant="1">
            {formatNumber(transaction.amount, 2)} AZN
          </S.Value>
        </S.Row>

        <S.Total>
          <Typography.Title $variant="1">
            {t('pages.cabinet.total')}
          </Typography.Title>
          <S.TotalValue $variant="1">
            {formatNumber(transaction.totalAmount, 2)} AZN
          </S.TotalValue>
        </S.Total>
      </S.Box>
    </Drawer>
  );
};
